// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var inject = allVue.inject;
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { allDay, messages } from '../../messages/main';
/** @hidden */
var DayViewAllDayRowContentVue2 = {
  name: 'KendoDayViewAllDayRowContent',
  props: {
    groupIndex: Number
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var localization = provideLocalizationService(this);
    return (
      // fragment
      h("div", {
        "class": "k-scheduler-cell k-heading-cell k-side-cell k-scheduler-times-all-day"
      }, [localization.toLanguageString(allDay, messages[allDay])])
    );
  }
};
/** @hidden */
var DayViewAllDayRowContent = DayViewAllDayRowContentVue2;
export { DayViewAllDayRowContent, DayViewAllDayRowContentVue2 };